// @ts-check
import { NodeType } from '@contentstack/utils';
import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import { ConstructBasicElement, ConstructCustomElement, GetCopyFromJson } from '~/contentstack/rendering';

import './AccentedTextSection.scss';

export const query = graphql`
	fragment AccentedTextFragment on Ozk_content_blockModular_blocksCopyContent {
		accented_text {
			accented_text_color
			accent_type
			text {
				json
			}
		}
	}
`;

/**
 * @typedef {'none' | 'hr' | 'disclosure' | 'left-gray-bar' | 'squashed' | 'center-red-bar'} AccentType

 * @typedef AccentedTextOptions
 * @property {AccentType} accent_type
 * @property {string} accented_text_color
 * @property {import('../CSTypes').CSJRTE[]} text
 * 
 * 
 * @typedef AccentedTextProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<AccentedTextOptions>} [options] 
 * 
 */
/** @type {React.FC<AccentedTextProps>} */
const AccentedTextSection = ({ options }) => {
	/** @type {Partial<import('../../contentstack/rendering').RenderOption>} */
	const renderOverrides = {};

	if (['left-gray-bar', 'none', 'squashed'].includes(options.accent_type)) {
		Object.assign(
			renderOverrides,
			ConstructCustomElement(NodeType.PARAGRAPH, (node, next) => (
				<React.Fragment>
					{next(node.children)}
					<br />
				</React.Fragment>
			))
		);
	} else if (options.accent_type === 'disclosure') {
		Object.assign(
			renderOverrides,
			ConstructBasicElement(NodeType.PARAGRAPH, 'p', { className: 'disclosure-p' }),
			ConstructBasicElement(NodeType.UNORDER_LIST, 'ul', { className: 'disclosure-ul' }),
			ConstructBasicElement(NodeType.ORDER_LIST, 'ol', { className: 'disclosure-ol' })
		);
	}

	const copy = GetCopyFromJson(options.text, renderOverrides);

	return (
		<div className={classNames('accented-text', options.accent_type)} style={{ color: options.accented_text_color }} {...options.$?.accented_text_color}>
			{copy}
		</div>
	);
};

export default AccentedTextSection;
